
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as guidebtbMKIm6eHJx3xEXDxsgSrsx38nSwuwejFrzAH5ecawMeta } from "/builds/web/WOWSP/mk_replays/frontend/pages/guide.vue?macro=true";
import { default as indexw9b44zSItxiJzHvYKzkssNTacWSCXeLKD959yZHJzq8Meta } from "/builds/web/WOWSP/mk_replays/frontend/pages/index.vue?macro=true";
import { default as find_45replayw09SK2oGGsu_2o_454bOHvFZ2bNfHqAW9DZ_JpUdOOWJMMeta } from "/builds/web/WOWSP/mk_replays/frontend/pages/find-replay.vue?macro=true";
import { default as _91id_93UZMlSyl_45IoRKQ2cPZLF4KFIbfOrezyPJnlC5bmmXCrMMeta } from "/builds/web/WOWSP/mk_replays/frontend/pages/replay/[id].vue?macro=true";
import { default as _91id_93mtgvaGxaonDYBWKtf0zkV4sxXC2rk0T1w4gYWzZLLVYMeta } from "/builds/web/WOWSP/mk_replays/frontend/pages/account/[id].vue?macro=true";
import { default as _91id_93nbVc2qV9HGgtMCOeJLkI2VNrdjPO4NdEOnMu9ZJ8VsUMeta } from "/builds/web/WOWSP/mk_replays/frontend/pages/contest/[id].vue?macro=true";
import { default as indexSGUjLIYbpXx9ItGWx4ShcRaQRQIzSoQdPS7eawLMM1UMeta } from "/builds/web/WOWSP/mk_replays/frontend/pages/contest/index.vue?macro=true";
import { default as uploadyK_45LjporWlxW_45PpT6vh7MmrsbGGCVAOj_SPAgxXq_DwMeta } from "/builds/web/WOWSP/mk_replays/frontend/pages/replay/upload.vue?macro=true";
export default [
  {
    name: "guide",
    path: "/guide",
    component: () => import("/builds/web/WOWSP/mk_replays/frontend/pages/guide.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/web/WOWSP/mk_replays/frontend/pages/index.vue")
  },
  {
    name: "find-replay",
    path: "/find-replay",
    component: () => import("/builds/web/WOWSP/mk_replays/frontend/pages/find-replay.vue")
  },
  {
    name: "replay-id",
    path: "/replay/:id()",
    component: () => import("/builds/web/WOWSP/mk_replays/frontend/pages/replay/[id].vue")
  },
  {
    name: "account-id",
    path: "/account/:id()",
    component: () => import("/builds/web/WOWSP/mk_replays/frontend/pages/account/[id].vue")
  },
  {
    name: "contest-id",
    path: "/contest/:id()",
    component: () => import("/builds/web/WOWSP/mk_replays/frontend/pages/contest/[id].vue")
  },
  {
    name: "contest",
    path: "/contest",
    component: () => import("/builds/web/WOWSP/mk_replays/frontend/pages/contest/index.vue")
  },
  {
    name: "replay-upload",
    path: "/replay/upload",
    meta: {"middleware":"auth"},
    component: () => import("/builds/web/WOWSP/mk_replays/frontend/pages/replay/upload.vue")
  }
]